<template>
  <modal
    :is-hidden="isHidden"
    :is-open="isOpen"
    :title="title ? $t(title) : ''"
    ref="modal"
    v-on:clickclose="cancelClick"
    :alert="text"
    :alertText="''"
    alertStyle="warning"
    :fixed="true"
    class="confirm-popup"
  >
    <template slot="footer">
      <button type="button" class="btn btn-sm" v-on:click="cancelClick">{{ $t(cancelLabel || 'Action.cancel') }}</button>
      <button type="button" class="btn btn-danger" v-on:click="acceptClick">{{ $t(acceptlLabel || 'Action.accept') }}</button>
    </template>
  </modal>
</template>
<script>

export default {
  props: {
    title: String,
    text: String,
    cancelLabel: String,
    acceptlLabel: String,
  },
  data() {
    return {
      isOpen: false,
      isHidden: true
    }
  },
  methods: {
    cancelClick() {
      this.$refs.modal.close(this);
      // this.isOpen = false;
      this.$emit('cancel')
    },
    acceptClick() {
      this.$refs.modal.close(this);
      // this.isOpen = false;
      this.$emit('accept')
    },
    openDialog(description) {
      this.$refs.modal.open(this);
      // this.isOpen = true;
    },
   }
}
</script>
<style>
.confirm-popup .modal-body {
  overflow: auto !important;
}
</style>